import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../App.css';
import axios from 'axios';
import { useProject } from '../ProjectContext';
import Sidebar from '../componenteExtra/SidebarSolicitante';
import { toast, Toaster } from 'react-hot-toast';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import SessionManager from '../componenteExtra/SessionManager';

const SolicitarServicioGET = () => {
  const [formData, setFormData] = useState({
    projectCode: '',
    projectName: '',
    partnerInCharge1: '',
    partnerInCharge2: '',
    businessName: '',
    serviceLine: '',
    holding: '',
    selectedType: '',
    regulacion: '',
    enlace: ''
  });
  const [showPopup, setShowPopup] = useState(false);
  const [tipoOpciones, setTipoOpciones] = useState([]);
  const [relatedProjects, setRelatedProjects] = useState([]);
  const [selectedProjects, setSelectedProjects] = useState([]);
  const [projectTypes, setProjectTypes] = useState({});
  const [emissionDates, setEmissionDates] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalFilialOpen, setIsModalFilialOpen] = useState(false);
  const [filialRows, setFilialRows] = useState([{ filial: formData.businessName }]);
  const [isRegulationModalOpen, setIsRegulationModalOpen] = useState(false);
  const [regulations, setRegulaciones] = useState([]);
  const [selectedDate, setSelectedDate] = useState(null);
  const [cutOffDate, setCutOffDate] = useState(null);
  const { setProjectInfo } = useProject();
  const navigate = useNavigate();
  const [nombre_get, setNombreGet] = useState('');

  const token = localStorage.getItem("access_token");

  useEffect(() => {
    const storedNombreGet = localStorage.getItem('nombre_get');
    setNombreGet(storedNombreGet);
  }, []);

  useEffect(() => {
    if (formData.projectCode) {
      axios.get(`${process.env.REACT_APP_BACKEND_URL}/get_tipo_solicitud`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then(response => {
          setTipoOpciones(response.data);
        })
        .catch(error => console.error('Error fetching tipo_solicitud:', error));
    }
  }, [formData.projectCode]);

  useEffect(() => {
    fetchRegulations();
  }, []);

  const fetchRegulations = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/get_regulaciones`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      setRegulaciones(response.data);
    } catch (error) {
      console.error('Error fetching regulations:', error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({ ...prevState, [name]: value }));
  };

  const handleFetchProject = async () => {
    if (!formData.projectCode) {
      setShowPopup(true);
    } else {
      setShowPopup(false);
      const toastId = toast.loading('Buscando proyecto...');
      try {
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/projects/${formData.projectCode}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
  
        const projectData = response.data[0];
        setFormData(prevState => ({
          ...prevState,
          projectCode: projectData.codigo_proyecto,
          projectName: projectData.nombre_proyecto,
          partnerInCharge1: projectData.nombre_responsable,
          partnerInCharge2: projectData.apellido_responsable,
          businessName: projectData.razon_social,
          serviceLine: projectData.nombre_linea_negocio,
          holding: projectData.holding,
          selectedType: prevState.selectedType,
          regulacion: projectData.regulacion || ''
        }));
        setFilialRows([{ filial: projectData.razon_social }]);
  
        // Si el proyecto ya está asignado, mostrar un toast de aviso
        if (projectData.project_assigned) {
          toast('⚠️ Este código de proyecto ya tiene solicitudes ingresadas en el sistema', {
            id: toastId,
            duration: 4000, // Duración de 4 segundos
            style: {
              background: '#ffeb99', // Amarillo más claro
              color: '#000',
              border: '1px solid rgb(231, 193, 121)',
              fontWeight: 'bold',
              fontSize: '17px', // Texto un poco más grande
              padding: '20px', // Aumenta el tamaño del cuadro
              borderRadius: '10px', // Bordes más suaves
            },
          });
        } else {
          toast.success('Proyecto encontrado', { id: toastId });
        }
      } catch (error) {
        // Verificar si el error es porque no se encontró el proyecto o si es un error de otra índole
        if (error.response && error.response.status === 404) {
          toast.error('Proyecto no encontrado', { id: toastId });
        } else {
          toast.error('Error al encontrar un proyecto', { id: toastId });
        }
        console.error('Error fetching project:', error);
      }
    }
  };

  const fetchRelatedProjects = async (holding) => {
    const toastId = toast.loading('Buscando más proyectos...');
    try {
      const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/super_projects_by_holding/${holding}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const relatedProjects = response.data.filter(project => project.codigo_proyecto !== formData.projectCode);
      setRelatedProjects(relatedProjects);
      setIsModalOpen(true);
      toast.success('Proyectos relacionados encontrados', { id: toastId });
    } catch (error) {
      toast.error('Error al buscar proyectos relacionados', { id: toastId });
      console.error('Error fetching related projects:', error);
    }
  };

  const handleAddFilialRow = () => {
    setFilialRows([...filialRows, { filial: "" }]);
  };

  const handleFilialRowChange = (index, field, value) => {
    const updatedRows = filialRows.map((row, idx) =>
      idx === index ? { ...row, [field]: value } : row
    );
    setFilialRows(updatedRows);
  };

  const handleRemoveFilialRow = (index) => {
    if (index !== 0) {
      setFilialRows(filialRows.filter((_, idx) => idx !== index));
    }
  };

  const handleSaveFilialRows = () => {
    // Actualizamos `businessName` con la primera fila y guardamos el resto como filiales adicionales.
    const mainFilial = filialRows[0].filial;  // Guardamos la primera filial como principal
    setFormData(prev => ({ ...prev, businessName: mainFilial }));  // Actualizamos el nombre de la filial principal

    // Solo mantenemos las filas que tienen nombre definido como filiales adicionales.
    const additionalFilials = filialRows.slice(1).filter(row => row.filial.trim() !== "");
    setProjectInfo(prev => ({
      ...prev,
      multipleFilials: additionalFilials,
    }));
    setIsModalFilialOpen(false);
  };

  const openRegulationModal = () => {
    setIsRegulationModalOpen(true);
  };

  const handleClear = () => {
    setFormData({
      projectCode: '',
      projectName: '',
      partnerInCharge1: '',
      partnerInCharge2: '',
      businessName: '',
      serviceLine: '',
      holding: '',
      selectedType: '',
      regulacion: '',
      enlace: ''
    });
    setTipoOpciones([]);
    setRelatedProjects([]);
    setSelectedProjects([]);
    setProjectTypes({});
    setSelectedDate(null);
    setEmissionDates({});
    setCutOffDate(null);
    setFilialRows([{ filial: "" }]);
    setIsModalFilialOpen(false);
  };

  const handleSelectRelatedProject = (project) => {
    setSelectedProjects(prev => [...prev, project]);
    setProjectTypes(prev => ({ ...prev, [project.codigo_proyecto]: '' }));
    setEmissionDates(prev => ({ ...prev, [project.codigo_proyecto]: null }));
  };

  const handleRemoveSelectedProject = (projectCode) => {
    setSelectedProjects(prev => prev.filter(p => p.codigo_proyecto !== projectCode));
    setProjectTypes(prev => {
      const newTypes = { ...prev };
      delete newTypes[projectCode];
      return newTypes;
    });
    setEmissionDates(prev => {
      const newDates = { ...prev };
      delete newDates[projectCode];
      return newDates;
    });
  };

  const handleRelatedProjectTypeChange = (projectCode, type) => {
    setProjectTypes(prev => ({ ...prev, [projectCode]: type }));
  };

  const handleRelatedProjectDateChange = (projectCode, date) => {
    setEmissionDates(prev => ({ ...prev, [projectCode]: date }));
  };

  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const urlPattern = /^(ftp|http|https):\/\/[^ "]+$/;

    if (!formData.projectCode || !formData.selectedType || Object.values(projectTypes).includes('') || !selectedDate) {
      setShowPopup(true);
    } else if (!urlPattern.test(formData.enlace)) {
      toast.error("Por favor ingrese un enlace válido.");
    } else {
      setShowPopup(false);
      setProjectInfo({
        projectCode: formData.projectCode,
        projectName: formData.projectName,
        partnerInCharge1: formData.partnerInCharge1,
        partnerInCharge2: formData.partnerInCharge2,
        businessName: formData.businessName,
        serviceLine: formData.serviceLine,
        holding: formData.holding,
        selectedType: formData.selectedType,
        regulacion: formData.regulacion,
        selectedDate: selectedDate,
        cutOffDate: cutOffDate,
        emissionDates: emissionDates,
        enlace: formData.enlace,
        multipleFilials: filialRows.slice(1), // Usamos solo filiales adicionales aquí
        selectedProjects: selectedProjects.map(p => ({
          ...p,
          selectedType: projectTypes[p.codigo_proyecto],
          emissionDate: emissionDates[p.codigo_proyecto] || null
        }))
      });

      if (selectedProjects.length > 0 || filialRows.length > 1) {
        navigate('/IngresarMultiplesSolicitudes');
      } else {
        navigate('/IngresarSolicitud');
      }
    }
  };

  const closeModal = () => setIsModalOpen(false);
  const closeRegulationModal = () => setIsRegulationModalOpen(false);

  const allRequiredFieldsFilled = formData.projectCode && formData.selectedType && formData.regulacion && selectedDate && cutOffDate;

  return (
    <div className="app">
      <SessionManager />
      <Sidebar />
      <div className="main-content">
        <Toaster />
        {showPopup && (
          <div className="popup">
            Por favor, complete todos los campos antes de continuar.
            <button onClick={() => setShowPopup(false)}>Cerrar</button>
          </div>
        )}
        <div className="form-container">
          <form onSubmit={handleSubmit} className="client-data-form">
            <h2 className="form-title">Bienvenido/a {nombre_get} <br />Ingrese el código de proyecto <br /><br /></h2>
            <div className="form-row">
              <div className="form-group">
                <label>Código de proyecto</label>
                <div className="input-button-group">
                  <input type="text" name="projectCode" value={formData.projectCode} onChange={handleChange} />
                  <button type="button" onClick={handleFetchProject} className="fetch-button">🔎 Buscar</button>
                  <button type="button" onClick={handleClear} className="clear-button">🧹 Limpiar</button>
                </div>
              </div>
              <div className="form-group">
                <label>Nombre de proyecto</label>
                <input type="text" name="projectName" value={formData.projectName} onChange={handleChange} disabled />
              </div>
            </div>
            <div className="form-row">
            <div className="form-group">
  <label>Filial</label>
  <div className="input-group">
    <input
      type="text"
      name="businessName"
      value={formData.businessName}
      onChange={handleChange}
      disabled
    />
  </div>
  {formData.businessName && (
    <button
      type="button"
      onClick={() => setIsModalFilialOpen(true)}
      className="purple-button"
      style={{ marginTop: '10px' }} // Espacio entre el input y el botón
    >
      Agregar Filiales
    </button>
  )}
</div>
              <div className="form-group">
                <label>Holding</label>
                <input type="text" name="holding" value={formData.holding} onChange={handleChange} disabled />
                {formData.holding && (
                  <button
                    type="button"
                    onClick={() => fetchRelatedProjects(formData.holding)}
                    className="purple-button"
                  >
                    Buscar Proyectos Relacionados
                  </button>
                )}
              </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label>Línea de servicio del profesional</label>
                <input type="text" name="serviceLine" value={formData.serviceLine} onChange={handleChange} disabled />
              </div>
              <div className="form-group">
                <label>Tipo de trabajo</label>
                <select
                  name="selectedType"
                  value={formData.selectedType}
                  onChange={handleChange}
                  required
                >
                  <option value="" disabled>Seleccione un tipo</option>
                  {tipoOpciones.map((option, index) => (
                    <option key={index} value={option}>{option}</option>
                  ))}
                </select>
              </div>
              <div className="form-group">
                  <label>Regulación</label>
                  <div className="input-button-group">
                    <input type="text" name="regulacion" value={formData.regulacion} onChange={handleChange} disabled />
                    <button 
                      type="button" 
                      onClick={openRegulationModal} 
                      className="purple-button"
                    >
                      Añadir/Cambiar Regulación
                    </button>
                  </div>
                </div>
            </div>

            <div className="form-row" style={{ display: 'flex', gap: '10px' }}>
              <div className="form-group" style={{ flex: 1 }}>
                <label>Fecha de emisión final</label>
                <DatePicker
                  selected={selectedDate}
                  onChange={handleDateChange}
                  minDate={new Date(new Date().setDate(new Date().getDate() + 7))}
                  maxDate={new Date(new Date().setMonth(new Date().getMonth() + 12))}
                  dateFormat="dd/MM/yyyy"
                  placeholderText="Seleccione una fecha"
                />
              </div>
              <div className="form-group" style={{ flex: 1 }}>
                <label>Fecha de corte auditoría</label>
                <DatePicker
                  selected={cutOffDate}
                  onChange={(date) => setCutOffDate(date)}
                  dateFormat="dd/MM/yyyy"
                  placeholderText="Seleccione una fecha"
                />
              </div>
            </div>

            <div className="form-group">
              <label>Enlace de documentación</label>
              <input
                type="url"
                name="enlace"
                value={formData.enlace}
                onChange={handleChange}
                placeholder="Ingrese un enlace válido"
                required
              />
            </div>

            {isModalOpen && (
              <div className="modal">
                <h3>Seleccionar Proyectos Relacionados</h3>
                <ul>
                  {relatedProjects.map((project, index) => (
                    <li key={index}>
                      <input
                        type="checkbox"
                        onChange={(e) => {
                          if (e.target.checked) {
                            handleSelectRelatedProject(project);
                          } else {
                            handleRemoveSelectedProject(project.codigo_proyecto);
                          }
                        }}
                      />
                      <span>{project.codigo_proyecto} - {project.nombre_proyecto} - {project.razon_social}</span>
                      {selectedProjects.some(p => p.codigo_proyecto === project.codigo_proyecto) && (
                        <>
                          <select
                            value={projectTypes[project.codigo_proyecto] || ''}
                            onChange={(e) => handleRelatedProjectTypeChange(project.codigo_proyecto, e.target.value)}
                            required
                          >
                            <option value="" disabled>Seleccione un tipo</option>
                            {tipoOpciones.map((option, idx) => (
                              <option key={idx} value={option}>{option}</option>
                            ))}
                          </select>
                          <div className="form-group">
                            <label>Fecha de emisión final para {project.codigo_proyecto}</label>
                            <DatePicker
                              selected={emissionDates[project.codigo_proyecto] || null}
                              onChange={(date) => handleRelatedProjectDateChange(project.codigo_proyecto, date)}
                              minDate={new Date(new Date().setDate(new Date().getDate() + 7))}
                              maxDate={new Date(new Date().setMonth(new Date().getMonth() + 12))}
                              dateFormat="dd/MM/yyyy"
                              placeholderText="Seleccione una fecha"
                            />
                          </div>
                        </>
                      )}
                    </li>
                  ))}
                </ul>
                <button onClick={closeModal} className="purple-button">Cerrar</button>
              </div>
            )}

            {isModalFilialOpen && (
              <div className="modal">
                <h2>Gestionar más filiales</h2>
                <h4>Utiliza esta opción si necesitas añadir filiales que no cuenten con códigos de proyecto propios y que se deban realizar diferentes actividades para cada filial.</h4>
                <table>
                  <thead>
                    <tr>
                      <th>Filial</th>
                      <th>Acciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filialRows.map((row, index) => (
                      <tr key={index}>
                        <td>
                          <input
                            type="text"
                            value={row.filial}
                            onChange={(e) => handleFilialRowChange(index, "filial", e.target.value)}
                            placeholder="Nombre de la Filial"
                            disabled={index === 0}
                          />
                        </td>
                        <td>
                          {index !== 0 && (
                            <button type="button" onClick={() => handleRemoveFilialRow(index)} className="delete-button">Eliminar</button>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <button type="button" onClick={handleAddFilialRow} className="add-button">Añadir nueva filial</button>
                <button type="button" onClick={handleSaveFilialRows} className="save-button">Guardar</button>
                <button type="button" onClick={() => setIsModalFilialOpen(false)} className="close-button">Cerrar</button>
              </div>
            )}

            {isRegulationModalOpen && (
              <div className="modal">
                <h3>Seleccionar Regulación</h3>
                <ul>
                  {regulations.map((regulation, index) => (
                    <li key={index}>
                      <input
                        type="radio"
                        name="selectedRegulation"
                        value={regulation}
                        onChange={(e) => setFormData(prev => ({ ...prev, regulacion: e.target.value }))}
                        checked={formData.regulacion === regulation}
                      />
                      <label>{regulation}</label>
                    </li>
                  ))}
                </ul>
                <button onClick={closeRegulationModal} className="purple-button">Guardar</button>
              </div>
            )}

            <button type="submit" className="continue-button" disabled={!allRequiredFieldsFilled || !cutOffDate}>Continuar</button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default SolicitarServicioGET;
